export default __webpack_public_path__ + "static/media/10.5a6ab86f.jpeg";